module.exports = __webpack_public_path__ + "static/img/a006.71befcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a006.jpg
// module id = dvFN
// module chunks = 0